var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdatePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7656 6C11.803 6 10.8928 6.22751 10.086 6.63161L9.08397 4.89604C10.1851 4.32349 11.437 4 12.7656 4C14.9756 4 16.9656 4.9 18.4156 6.35L20.7656 4V11H13.7656L16.9856 7.78C15.9056 6.69 14.4256 6 12.7656 6ZM8 18.4247C9.32957 19.4145 10.9781 20 12.7656 20C16.4956 20 19.6056 17.45 20.4956 14H18.4156C17.5956 16.33 15.3756 18 12.7656 18C11.5409 18 10.401 17.6317 9.45089 17H9.42466L8 18.4247Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 10V8.5C7.8 7.1 6.4 6 5 6C3.6 6 2.2 7.1 2.2 8.5V10C1.6 10 1 10.6 1 11.2V14.7C1 15.4 1.6 16 2.2 16H7.7C8.4 16 9 15.4 9 14.8V11.3C9 10.6 8.4 10 7.8 10ZM6.5 10H3.5V8.5C3.5 7.7 4.2 7.2 5 7.2C5.8 7.2 6.5 7.7 6.5 8.5V10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatePassword);
export default __webpack_public_path__ + "static/media/update_password.40552cf0.svg";
export { ForwardRef as ReactComponent };